import React, { useState, useEffect, useRef } from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const ITCareerSkillsSection = () => {
  return <CareerSkillsSection />;
};

export default ITCareerSkillsSection;
